import mediator from "@tvg/mediator";
import { LogoutProcessInitiatedEventProps } from "./types";

export const logoutProcessInitiatedEvent = ({
  loggedOutBy = ""
}: LogoutProcessInitiatedEventProps) => {
  mediator.base.dispatch({
    type: "LOGOUT_PROCESS_INITIATED",
    payload: { loggedOutBy }
  });
};

export const logoutButtonClickedEvent = () => {
  mediator.base.dispatch({
    type: "LOGOUT_BUTTON_CLICKED"
  });
};
